import React from 'react';
import { Layout } from 'antd';

import Header from 'components/navigation/Header';
import withAuthorization from 'components/navigation/withAuthorization';

class Root extends React.Component {
  render() {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Header />
        <Layout>
          {this.props.children}

          {/* <Layout.Footer style={{ textAlign: 'center' }}>
            Convodo - 2019
          </Layout.Footer> */}
        </Layout>
      </Layout>
    );
  }
}

export default withAuthorization(Root);

